export default __webpack_public_path__ + "static/media/img-slider-urban-transit-1.e3dcd908.png";